import type { Application } from '@/services/composite-service/composite-service';

/**
 * Utility function to check if user has only Knowledge Library (KL) access
 * Returns true if user has exactly one application and it's 'KL'
 */
export function hasOnlyKlAccess(applications?: Application[]): boolean {
  return (
    applications?.length === 1 && applications[0]?.applicationCode === 'KL'
  );
}
